import { HttpClient } from "@/plugins/httpClient";

var httpClient = new HttpClient(`${process.env.VUE_APP_API_URL}/owner`);

export async function registerClinic(body) {
  return await httpClient.post("/clinics", {}, body);
}
